import data from '../../data.json';
import expoImg from '../img/img-card/expoautosgroup.jpeg';
import piopioImg from '../img/img-card/piopio.jpg';
import reactImg from '../img/react.png';
import javascriptImg from '../img/javascript.png';
import nodejs from '../img/nodejs.png';
// EXPOAUTOSGROUP
data[0].image = expoImg
data[0].tools[0].imgTool = reactImg
data[0].tools[1].imgTool = nodejs
data[0].tools[2].imgTool = javascriptImg

//lOS PIO PIO
data[1].image = piopioImg
data[1].tools[0].imgTool = reactImg
export default data